import {createSelector} from 'reselect';

const createListingSelector = (state) => state && state.createListing || {};

export const listingIdCreatedSelector = createSelector(
  createListingSelector,
  ({listingId = null}) => listingId
);
